import { Encounter } from '../pages/utils';
import { GET_MEDICAL_RECORDS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface MedicalRecordsResponse {
    documents?: DocumentsEntity[] | null;
    encounters?: Encounter[];
    source_refreshed_at?: number;
    poll?: boolean;
}
export interface DocumentsEntity {
    patient_name: string;
    document_type: string;
    doctor_id: string;
    thumbnail: string;
    document_date: string;
    display_dd: string;
    authorizer: string;
    document_id: string;
    files_count: number;
    files?: { asset_url: string; file_type: string; share_text: string }[];
    Tag: string;
    uploaded_by_me?: boolean;
    is_processing?: boolean;
    is_analyzing?: boolean;
    is_smart_report_available?: boolean;
    oid?: string;
    user_tags?: string[];
    search_meta: {
        highlight: string;
    };
    latest_document_type?: string;
    notes?: number;
    u_at: number;
}

export const NO_ACCESS = 'NO_ACCESS';

export default (
    ptId: string,
    search_term?: string,
    withRefresh?: boolean,
    limit?: boolean,
): Promise<MedicalRecordsResponse> => {
    return fetchWithRefresh(GET_MEDICAL_RECORDS(ptId, search_term, withRefresh, limit)).then(
        (res) => {
            if (res.status === 200) {
                return res.json();
            } else if (res.status === 403) {
                // no access
                throw new Error(NO_ACCESS);
            } else {
                throw new Error('failed to fetch medical records');
            }
        },
    );
};
